export default "assets/images/forme-6a45be10.svg";